<template>
  <div class="QHleftcity">
    <ul class="QHleftcityscroll">
      <li :class="{ on: code == $getCityFuqin('code') }" @click="tabEqFun($getCityFuqin('code'), $getCityFuqin('level'), $getCityFuqin('name'))">
        {{ $getCityFuqin("name") }}
      </li>
      <li :class="{ on: code == item.code }" @click="tabEqFun(item.code, item.level, item.name)" v-for="(item, index) in $getCitySon()" :key="index">{{ item.name }}</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "QHleftcity",
  data() {
    return {
      code: "",
    };
  },
  methods: {
    // +----------------------------------------------------------------------
    // | Desc:初次加载
    // +----------------------------------------------------------------------
    int() {
      this.tabEqFun(this.$getCityFuqin("code"), this.$getCityFuqin("level"), this.$getCityFuqin("name"));
    },

    // +----------------------------------------------------------------------
    // | Desc:切换地址
    // +----------------------------------------------------------------------
    tabEqFun(code, level, name) {
      var that = this;
      //请求下级城市
      this.code = code;
      var streetList = "";
      var data = {};
      data["code"] = code;
      data["level"] = level;
      data["name"] = name;
      that.$emit("cityLoading", data);
      if (this.$getCityFuqin("level") == 2 && level == 3) {
        this.getStreetList(code, function (list) {
          //组合数据返回
          data["streetList"] = list;
          that.$emit("change", data);
        });
      } else {
        //组合数据返回
        data["streetList"] = streetList;
        that.$emit("change", data);
      }
    },

    // +----------------------------------------------------------------------
    // | 获取街道列表
    // +----------------------------------------------------------------------
    getStreetList(code, callback) {
      var https = {
        type: "isApi",
        api: this.$api.getStreetList,
        parameter: {
          code: code,
        },
      };
      this.$httpsApi(https, function (res) {
        callback && callback(res.data);
      });
    },
  },
};
</script>
<style scoped>
.QHleftcity {
  width: 105px;
  height: calc(100% - 60px);
  position: fixed;
  left: 0;
  top: 60px;
  background: #0355bb !important;
  z-index: 100;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.4);
}
.QHleftcityscroll {
  border-right: 1px solid #1a6bd6 !important;
  width: 105px;
  height: 100%;
  padding-top: 2px;
  box-sizing: border-box;
  overflow-y: auto;
}
.QHleftcityscroll li {
  color: rgba(255, 255, 255, 0.8);
  font-size: 17px;
  cursor: pointer;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  font-weight: 700;
  padding: 10px 5px;
  text-align: center;
}
.QHleftcityscroll li:hover {
  color: rgba(255, 255, 255, 1);
}
.QHleftcityscroll li.on {
  background: #f66702;
  color: #fff;
  font-weight: 700;
}
.QHleftcityscroll li span {
  display: block;
}
</style>
